export default __webpack_public_path__ + "static/media/iconSchool.be646903.png";